module.exports = __webpack_public_path__ + "img/StarLinks.5497b12d.png";